import Vue from 'vue';
import Vuex from 'vuex';

import app_settings from './modules/app-settings';
import page_loader from './modules/page-loader';
import token from './modules/token';
import tracing from './modules/tracing';
import lookups from './modules/lookups';
import quote from './modules/quote';
import ofgem_averages from './modules/ofgem-averages';
import quote_questions from './modules/quote/questions';
import help_me_estimate from './modules/help-me-estimate';
import help_me_estimate_questions from './modules/help-me-estimate/questions';
import quote_results from './modules/quote-results';
import tariff_details from './modules/tariff-details';
import carbon_offset from './modules/carbon-offset';

import personal_details_customer from './modules/personal-details/customer';
import personal_details_address from './modules/personal-details/address';
import personal_details_terms from './modules/personal-details/terms';
import personal_details_payment from './modules/personal-details/payment';
import personal_details_switch_plan from './modules/personal-details/switch-plan';

import error from './modules/error';
import storage from './modules/storage';
import email from './modules/email';
import session from './modules/session';

// import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app_settings,
    page_loader,
    token,
    tracing,
    lookups,
    quote,
    ofgem_averages,
    quote_questions,
    help_me_estimate,
    help_me_estimate_questions,
    quote_results,
    tariff_details,
    carbon_offset,

    personal_details_customer,
    personal_details_address,
    personal_details_terms,
    personal_details_payment,
    personal_details_switch_plan,

    error,
    storage,
    email,
    session
  }
});
